import { SystemPermissions } from "../common/permissions";
import { useUserInfo } from "./useUserInfo";

export function usePermissions(){
    const userInfo = useUserInfo();
    let permissions = {
        Read: false,
        Edit: false,
        FullControl: false
    };


    if(Array.isArray(userInfo.permissions) && userInfo.permissions.length > 0){
        userInfo.permissions.map(x =>{
            if(SystemPermissions[x]){
                permissions[SystemPermissions[x]] = true
            }
        })
    }

    if(permissions.FullControl){
        permissions.Edit = true
        permissions.Read = true
    }
    else if(permissions.Edit){
        permissions.Read = true
    }

    return permissions;
}